<div class="flex flex-row items-center gap-4">
    <button class="primary-btn my-2" (click)="addNewRssFeed()">Add Category</button>
</div>

<table mat-table [dataSource]="dataSource" matSort class="!w-full !inline-table table-alternate">

    <ng-container matColumnDef="ID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
        <td mat-cell *matCellDef="let element">
            {{ element.id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="feed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="feed">Category</th> <td mat-cell *matCellDef="let element">
            <div class="hover:text-blue-800 hover:underline cursor-pointer" (click)="editRssFeed(element)">
               {{ element.feed }}
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="url">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="url">URL</th> <td mat-cell *matCellDef="let element">
            {{ element.url }}
        </td>
    </ng-container>

    <ng-container matColumnDef="switchboard_template_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="switchboard_template_name">Switchboard Template</th> <td mat-cell *matCellDef="let element">{{ element.switchboard_template_name }}</td>
    </ng-container>

    <ng-container matColumnDef="site_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="site_name">Social Page/Site</th> <td mat-cell *matCellDef="let element">{{ element.Domain }}</td>
    </ng-container>

    <ng-container matColumnDef="isApproved">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="isApproved">Approval Status</th>
        <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-40 mt-3">
                <mat-select [(ngModel)]="element.isApproved" (selectionChange)="onStatusChange(element)"
                    class="flex justify-center">
                    <mat-option *ngIf="element.isApproved === 'Pending'" value="Pending">Pending</mat-option>
                    <mat-option value="Approved">Approved</mat-option>
                    <mat-option value="Not Approved">Not Approved</mat-option>
                </mat-select>
            </mat-form-field>
        </td>
    </ng-container>

      <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Delete</th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button (click)="$event.stopPropagation();openDeleteRssFeedConfirm(element)"
        class="!bg-red-500 !text-white">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [length]="totalItems" [pageSize]="12" showFirstLastButtons>
</mat-paginator>

<ng-template #rssFeedFormTmpl>
    <app-rss-feeds-form [formData]="rssFeed" (onSubmitClbk)="onSubmitClbk()" [companyID]="rssFeed.companyID"></app-rss-feeds-form>
</ng-template>

<ng-template #confirmDeleteTmpl>
    <div class="flex flex-col gap-4">
        <p>Are you sure you want to delete <b>{{ rssFeed.feed }}</b>?</p>
        <div class="flex flex-row items-center justify-center gap-2">
            <button mat-button (click)="deleteFeed()">Confirm</button>
            <button mat-button (click)="dialog.closeAll();">Cancel</button>
        </div>
    </div>
</ng-template>
